import { ApiService } from '../../../shared/services/api.service';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ContextScreenService {
  constructor(private apiService: ApiService) {
  }
	fetchTemplates() {
		return this.apiService.get('/api/mvp/dfb/get/getDFBTemplates')
		  .map(
		  data => {
			return data;
		  }
		  );
	}
	
	fetchProducts() {
		return this.apiService.get('/api/mvp/get/primaryCategoryItems?categoryMasterId=4EE68207B1F6468F865511BC41A907D6')
		  .map(
		  data => {
			return data;
		  }
		  );
	}
	fetchTemplateContext() {
		return this.apiService.get('/api/mvp/dfb/getalltemplatecontext')
		  .map(
		  data => {
			return data;
		  }
		  );
	}
	
	fetchSubproducts(productId) {
		return this.apiService.get('/api/mvp/get/secondaryCategoryItemByParentId?parentId='+productId)
		  .map(
		  data => {
			return data;
		  }
		  );
	}
	
	addTemplateContext(data) {
		// data.id = "39e1061198d04288d81ec681a7f3e2b7"
		return this.apiService.post('/api/mvp/dfb/addtemplatecontext', data)
		  .map(
			(response: Response) => {
			  return response;
			}
		  )
		  .catch(
			(error: Response) => {
			  return Observable.throw('Something went wrong');
			}
		  );
	}
	
	editTemplateContext(data) {
		// data.id = "39e1061198d04288d81ec681a7f3e2b7"
		return this.apiService.post('/api/mvp/dfb/edittemplatecontext', data)
		  .map(
			(response: Response) => {
			  return response;
			}
		  )
		  .catch(
			(error: Response) => {
			  return Observable.throw('Something went wrong');
			}
		  );
	}

}





// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/context_screen/context.service.ts